/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown> }} Workout_After_Carry_Why_AddedInputs */

const en_us2_workout_after_carry_why_added = /** @type {(inputs: Workout_After_Carry_Why_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You added it today (${i?.sets} sets done). Off, it stays today's only; on, it joins your plan at the plan's dose.`)
};

const pt_br2_workout_after_carry_why_added = /** @type {(inputs: Workout_After_Carry_Why_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você incluiu hoje (${i?.sets} séries feitas). Desligado, fica só para hoje; ligado, entra no plano com a dose do plano.`)
};

const es_419_workout_after_carry_why_added = /** @type {(inputs: Workout_After_Carry_Why_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lo agregaste hoy (${i?.sets} series hechas). Desactivado, queda solo para hoy; activado, entra en tu plan con la dosis del plan.`)
};

const pt_pt2_workout_after_carry_why_added = /** @type {(inputs: Workout_After_Carry_Why_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Incluíste-o hoje (${i?.sets} séries feitas). Desligado, fica só para hoje; ligado, entra no plano com a dose do plano.`)
};

const fr_fr2_workout_after_carry_why_added = /** @type {(inputs: Workout_After_Carry_Why_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu l'as ajouté aujourd'hui (${i?.sets} séries faites). Désactivé, il reste pour aujourd'hui seulement ; activé, il entre dans ton programme avec la dose du programme.`)
};

const de_de2_workout_after_carry_why_added = /** @type {(inputs: Workout_After_Carry_Why_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast sie heute hinzugefügt (${i?.sets} Sätze erledigt). Aus: Sie bleibt nur heute. An: Sie kommt mit der Dosis des Plans in deinen Plan.`)
};

const it_it2_workout_after_carry_why_added = /** @type {(inputs: Workout_After_Carry_Why_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'hai aggiunto oggi (${i?.sets} serie fatte). Spento, resta solo per oggi; acceso, entra nella scheda con la dose della scheda.`)
};

/**
* | output |
* | --- |
* | "You added it today ({sets} sets done). Off, it stays today's only; on, it joins your plan at the plan's dose." |
*
* @param {Workout_After_Carry_Why_AddedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_why_added = /** @type {((inputs: Workout_After_Carry_Why_AddedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_Why_AddedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_why_added(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_why_added(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_why_added(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_why_added(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_why_added(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_why_added(inputs)
	return en_us2_workout_after_carry_why_added(inputs)
});
export { workout_after_carry_why_added as "workout-after.carry_why_added" }